var render, staticRenderFns
import script from "./CategoryServiceFieldComponent.vue?vue&type=script&lang=js&"
export * from "./CategoryServiceFieldComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/releases/338/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38623b38')) {
      api.createRecord('38623b38', component.options)
    } else {
      api.reload('38623b38', component.options)
    }
    
  }
}
component.options.__file = "resources/js/pages/components/fields/CategoryServiceFieldComponent.vue"
export default component.exports